import type {ComposerTranslation} from "vue-i18n";

export const getEducationOptions = (t: ComposerTranslation) => {
  return [
    {value: "UNSPECIFIED", text: t("NOT_SPECIFIED")},
    {value: "PRIMARY", text: t("EDU_PRIMARY")},
    {value: "BASIC", text: t("EDU_BASIC")},
    {value: "SECONDARY", text: t("EDU_SECONDARY")},
    {value: "VOCATIONAL", text: t("EDU_VOCATIONAL")},
    {value: "HIGHER", text: t("EDU_HIGHER")},
  ];
};
